import { __read } from "tslib";
export var getQueryParams = function () {
    /* istanbul ignore if */
    if (typeof window === 'undefined') {
        return {};
    }
    var pairs = window.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function (acc, curr) {
        var _a = __read(curr.split('=', 2), 2), key = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
        if (!value) {
            return acc;
        }
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
    }, {});
    return params;
};
//# sourceMappingURL=query-params.js.map